module.exports = __webpack_public_path__ + "img/item2.522f1351.jpeg";